import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
function getInsuranceList(data) {
    return Networking.PostApi(ApiValues.getInsuranceList, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}
export default getInsuranceList